import { RootState } from '..';
import { useSelector as reduxUseSelector } from 'react-redux';
import { LoaderState } from './slice';

export const createLoaderHooks = (useSelector: typeof reduxUseSelector) => ({
  useLoadingIndicator: (...flags: (keyof LoaderState)[]) =>
    useSelector((state: RootState) => (flags.find((key) => state.loader[key]) ? true : false)),
});
